import _ from 'lodash';

import { usePermissionContext, useWorkspaceContext } from '../context';

export enum NativeSearchAction {
  VIEW_NATIVE_SEARCH_ACCOUNTS = 'VIEW_NATIVE_SEARCH_ACCOUNTS',
  DELETE_JOB_BOARD_ACCOUNTS = 'DELETE_JOB_BOARD_ACCOUNTS',
  MANAGE_NATIVE_SEARCH_ACCOUNTS = 'MANAGE_NATIVE_SEARCH_ACCOUNTS',
}

export const useNativeSearchAccessControl = (actions: NativeSearchAction[]) => {
  const workspace = useWorkspaceContext();
  const permissionContext = usePermissionContext();
  const data = actions.map(
    (action) =>
      !_.isEmpty(workspace.role) &&
      permissionContext.isAuthorized &&
      permissionContext.isAuthorized('NATIVE_SEARCH', action, [workspace.role ?? ''])
  );
  return { access: data, owns: workspace.owns };
};
